import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    parentCase: null,
    caseCheckId: null,
};

const newCaseSlice = createSlice({
    initialState,
    name: "new_case",
    reducers: {
        setParentCase: (state, action) => {
            state.parentCase = action.payload.parentCase;
            state.caseCheckId = action.payload.caseCheckId;
        },
        clearParentCase: (state) => {
            state.parentCase = null;
            state.caseCheckId = null;
        },
    }
});

export default newCaseSlice.reducer;

export const {
    setParentCase,
    clearParentCase
} = newCaseSlice.actions;
